/*跨域地址*/
const dev = process.env.dev
const rescApi = process.env.rescApi
const wxlogin = process.env.wxlogin

export default {
  //微信保存渠道浏览记录
  postDACVisit: {
    url: rescApi + '/dac/order/visit',
    method: 'post'
  },
  //子渠道是否添加问卷开关
  questionSwitch: {
    url: dev + '/noauth/h5/order/channel/sub/question/switch',
    method: 'get'
  },
  //数字化获客赋能提交订单
  DACSubmit: {
    url: dev + '/noauth/h5/order/commit/dac',
    method: 'post'
  },
}



// WEBPACK FOOTER //
// ./src/api/pc.js